module.exports = require('./lib/react.js')



//////////////////
// WEBPACK FOOTER
// ./~/_glamor@2.20.40@glamor/react.js
// module id = 1
// module chunks = 0